import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCategory = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#e3e3e3",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M100-160v-289.23h289.23V-160H100Zm60-60h169.23v-169.23H160V-220Zm92.31-360 192.31-315.38L636.92-580H252.31Zm105.84-60h172.93l-86.46-139.08L358.15-640ZM863.77-64.31 758.54-169.54q-19.85 14.38-43.58 21.96-23.73 7.58-50.34 7.58-68.85 0-116.73-47.89Q500-235.77 500-304.62q0-68.84 47.89-116.73 47.88-47.88 116.73-47.88 68.84 0 116.73 47.88 47.88 47.89 47.88 116.73 0 26-7.58 49.54-7.57 23.54-20.96 43.39l105.23 105.23-42.15 42.15ZM664.6-200q43.94 0 74.29-30.34 30.34-30.33 30.34-74.26 0-43.94-30.33-74.29-30.34-30.34-74.27-30.34-43.94 0-74.28 30.33Q560-348.56 560-304.63q0 43.94 30.34 74.28Q620.67-200 664.6-200ZM329.23-389.23ZM444.62-640Z" })
});
export default SvgCategory;
